import req from '@/utils/req.js'


//外联渠道添加
export function insertReturnId(params) {
    return req.post("/dsicm-contact-platform/feign/outside-chain-channel/insertReturnId", params)
}

//外联渠道列表
export function page(params) {
    return req.post("/dsicm-contact-platform/feign/outside-chain-channel/page", params)
}

//外联渠道启用禁用
export function publish(params) {
    return req.put(`/dsicm-contact-platform/feign/outside-chain-channel/updateStatus/${params.id}`, params);
}







